import { useState  } from 'react'
import './styles.css'

import banner from "../../assets/pictures/bannerHotel.png"
import letters from '../../assets/images/letterTours.png'

import Find from '../share/components/Find/Find'
import CarouselSevices, { servicesTravel } from '../share/components/CarouselServices/CarouselSevices'



import HotelSearchEngine from './HotelSearchEngine/HotelSearchEngine'




const Hotel = () => {

   

  

   

    return (
        <div>
            <Find></Find>
            <header className='header-hotel'>
                <HotelSearchEngine titleSize={'30px'} iconTitleSize={'50'} containDateFlexDirection={'row'} containDateJustify={'space-between'} layoutCampoWidth={'47%'} containFinishFlexDirection={'row'} containFinishJustify={'space-between'} layoutCampoVWidth={'47%'} />

                <div className='contain-banner-hotel'>
                    <img className='banner-img' src={banner} alt="" />
                    <div className='effect-black-hotel'>
                        <section className='text-Banner-hotels'>
                            <img className='img-letter-hotel' src={letters} alt="espcialist" />
                            <p>Selecciona el hospedaje en cualquier lugar del mundo, descansa como en casa.</p>
                        </section>
                    </div>
                </div>


            </header>
            
            <CarouselSevices
                current={servicesTravel[1].title}
            />


        </div>
    )
}

export default Hotel